<template>
    <v-row class="mt-2">
        <v-col cols="12" class="d-flex pt-0">
            <div class="title font-weight-medium g5--text mr-2">{{ $t('Planned') }}</div>
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-icon size="18" v-on="on">
                        mdi-information-outline
                    </v-icon>
                </template>
                {{ $t('Automated emails scheduled to be sent in the future') }}
            </v-tooltip>
        </v-col>
        <v-col
            v-for="(emailAutomation, index) in emailAutomations"
            :key="index"
            cols="12"
            class="d-flex align-center py-2"
        >
            <div class="planned-icon mr-3">
                <v-icon class="white">mdi-email</v-icon>
                <div class="planned-icon-line" />
            </div>
            <PlannedEmailText
                :email-automation="emailAutomation"
                show-task-title
                @select="selectAutomation(emailAutomation)"
            />
        </v-col>
    </v-row>
</template>

<script>
import TaskModule from "@/store/modules/task";
import { $t } from "@/i18n";
import PlannedEmailText from "@/components/Emailing/PlannedEmailText/Index"

export default {
    name: "CommunicationPlanned",
    components: {
        PlannedEmailText
    },
    props: {
        emailAutomations: {
            type: Array,
            required: true
        }
    },
    setup(props, ctx) {
        const { openTask } = TaskModule();

        const selectAutomation = (emailAutomation) => {
            if (emailAutomation.task_id) {
                openTask(emailAutomation.task_id)
            } else {
                ctx.emit('edit-automation', emailAutomation.id)
            }
        }

        return {
            openTask,
            selectAutomation
        };
    }
};
</script>

<style scoped lang="scss">
.planned-icon {
    position: relative;

    .v-icon {
        border-radius: 100%;
        border: 1px dashed var(--v-g5-base) !important;
        padding: 6px;
    }

    .planned-icon-line {
        border: 1px dashed var(--v-g4-base) !important;
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translate(-50%, 100%);
        height: 100%;
    }
}
</style>